require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2006-02-18-blog-software-for-my-mother.json") })
        }
      }, "path---articles-2006-02-18-blog-software-for-my-mother");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2006-02-18-blog-software-for-my-mother!./.cache/json/articles-2006-02-18-blog-software-for-my-mother.json
// module id = 453
// module chunks = 231608221292675